import cloneDeep from "lodash.clonedeep";
import { actions } from "./actions";
import { DEFAULT_STATE } from "./state";
import { mutationTypes, getterTypes } from "./types";

export default {
    actions,
    mutations: {
        [mutationTypes.countryGetDataStart](state) {
            state.isLoading = true;
        },
        [mutationTypes.countryGetDataSuccess](state, data) {
            state.isLoading = false;
            state.countries = data;
        },
        [mutationTypes.countryGetDataFailure](state) {
            state.isLoading = false;
        },
        [mutationTypes.setBankCountry](state, country) {
            state.bankCountry = country;
        },
        [mutationTypes.setPublisherCountry](state, country) {
            state.publisherCountry = country;
        },
    },
    getters: {
        [getterTypes.getPublisherCountry](state) {
            return state.publisherCountry;
        },
        [getterTypes.getBankCountry](state) {
            return state.bankCountry;
        },
        [getterTypes.getCountries](state) {
            return state.countries;
        },
    },
    state: cloneDeep(DEFAULT_STATE),
};
